import "dayjs/locale/zh-cn";
import "@/styles/globals.css";

import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import dayjs from "dayjs";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "@/App";

dayjs.locale("zh-cn");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        components: {
          Form: {
            // vertical 布局 label
            verticalLabelPadding: 2,
            labelColor: "#737373",
          },
          Table: {
            // 表头：灰底 + 12px + 字重 500
            headerBg: "#fafafa",
            headerColor: "#595959",
            fontWeightStrong: 500,
            fontSize: 12,
            // 表体：13px + 上下 padding 10（行高约 40px，line-height 见 globals.css）
            cellFontSize: 13,
            cellFontSizeMD: 13,
            cellFontSizeSM: 13,
            cellPaddingBlock: 10,
            cellPaddingBlockMD: 10,
            cellPaddingBlockSM: 10,
            colorText: "#737373",
            // 行 hover：浅橙实色，避免 fixed 列与半透明背景叠层问题
            rowHoverBg: "#fff9f6",
          },
        },
        token: {
          borderRadius: 10,
          // 平台品牌橙：列表页、主按钮、激活态统一使用
          colorPrimary: "#f97316",
          controlHeight: 36,
        },
      }}
    >
      <App />
    </ConfigProvider>
  </StrictMode>,
);
